import React, { Component } from 'react';


export class Home extends Component {
  render() {
    return (
      <div className='d-flex align-items-center justify-content-center' style={{ height: "100vh" }}>
        <h1>Welcome to my restaurant</h1>
      </div>
    )
  }
}

export default Home;
